module.exports = __webpack_public_path__ + "static/media/SmartShop_5-615w.79c91b09.png";